/* global google */

var mapRequest

export function initMap(ops) {
  setTimeout(() => {
    try {
      startMap(ops);
    } catch (error) { }
  }, 500);
}
function startMap(ops) {
  mapRequest = new google.maps.Map(document.getElementById(ops.id), {
    center: ops.center,
    zoom: ops.zoom,
  });

  new google.maps.Marker({
    position: ops.center,
    map: mapRequest,
  })

  new google.maps.StreetViewPanorama(
    document.getElementById(ops.svid),
    {
      position: ops.center,
      pov: {
        heading: 34,
        pitch: 10,
      },
      map: mapRequest
    }
  )
}